import { State } from 'src/reducers/types'
import { TeamRole, TeamPermissions } from 'src/interfaces/team'

export const getTeamMemberInvitesCount = (state: State): number | null =>
  state.team.teamMemberInvitesCount

export const getTeamMembersCount = (state: State): number | null => state.team.teamMembersCount

export const getTeamRoles = (state: State): TeamRole[] | null => state.team.teamRoles

export const getTeamPermissions = (state: State): TeamPermissions | null =>
  state.team.teamPermissions
